import { PhoneStorageBreakdown, storageBytes } from '@/components/admin/PhoneStorageBreakdown';
import React from 'react';
import {Dialog,DialogContent,DialogHeader,DialogTitle,DialogDescription} from '@/components/ui/dialog';
import {Button} from '@/components/ui/button';
import type {OperatorPhoneReport} from './operatorDeliveryStatus';
import {formatPhoneReportTime} from './operatorDeliveryStatus';
import {phonePlatform,phoneSummary} from './operatorActionList';
import {OperatorCycleHealth} from './OperatorCycleHealth';
import {OperatorConnection} from './OperatorConnection';

export function OperatorPhoneDetails({name,report,cycleId,stores,onClose,onSupport}:{
 name:string;report:OperatorPhoneReport|undefined;cycleId:number;stores:Array<{storeId:number;storeName:string}>;
 onClose:()=>void;onSupport:()=>void;
}){
 const phone=phoneSummary(report);
 const waiting=report?.unsafeStatusReadOk===true ? report.unsafeCount : null;
 const storageRead=report?.storageTelemetryReadOk!==false;
 return <Dialog open onOpenChange={open=>{if(!open)onClose();}}><DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
  <DialogHeader><DialogTitle>Device Health — {name}</DialogTitle><DialogDescription className="sr-only">Information from the last phone check.</DialogDescription></DialogHeader>
  <div className="space-y-5 text-sm">
   <section className="space-y-2"><h3 className="font-semibold">Last phone check</h3><p>{phone.label}</p><p>{report?.createdAt?formatPhoneReportTime(report.createdAt):'No phone check has been received.'}</p>
    <p className="text-muted-foreground">{report?.osName?phonePlatform(report.osName):'Phone type not reported'} · App {report?.appVersion??'version not reported'}</p>
   </section>
   <OperatorConnection report={report}/>
   <section className="space-y-2"><h3 className="font-semibold">What was waiting on the phone</h3>
    <p>{waiting==null?'The phone did not report how much work was waiting.':waiting===0?'Nothing was waiting to send at this check.':`${waiting} saved items were waiting to send at this check.`}</p>
    <p className="text-muted-foreground">Includes photos, job results and signatures across all stores and cycles.</p>
    {report?.unsafeStatusReadOk && <dl className="grid grid-cols-2 gap-2">
     <dt>Could not send</dt><dd>{report.unsafeCounts?.failed??'Not reported'}</dd>
     <dt>Need technical help</dt><dd>{report.unsafeCounts ? (report.unsafeCounts.failed_permanent??0)+(report.unsafeCounts.conflict??0) : 'Not reported'}</dd>
    </dl>}
   </section>
   <section className="space-y-2"><h3 className="font-semibold">Data kept by ReActor on this phone</h3>
    <dl className="grid grid-cols-2 gap-2">
     <dt>Database size</dt><dd>{storageRead&&report?.dbSizeMb!=null?`${report.dbSizeMb} MB`:'Not reported'}</dd>
     <dt>Photo files stored</dt><dd>{storageRead?(report?.offlineMediaFileCount??'Not reported'):'Not reported'}</dd>
     <dt>Photo file size</dt><dd>{storageRead&&report?.offlineMediaBytes!=null?storageBytes(report.offlineMediaBytes):'Not reported'}</dd>
     <dt>Already-sent items kept</dt><dd>{storageRead?(report?.outboxSuccessRowCount??'Not reported'):'Not reported'}</dd>
     <dt>Last cleanup reported</dt><dd>{report?.lastLocalRetentionAt?formatPhoneReportTime(report.lastLocalRetentionAt):'Not reported'}</dd>
    </dl><p className="text-muted-foreground">These figures include saved history. They do not show how much free storage the phone has.</p>
   </section>
   <PhoneStorageBreakdown diagnostics={report?.storageDiagnostics} cycleNames={report?.storageCycleNames}/>
   <details><summary className="cursor-pointer font-semibold">Waiting work by store</summary><div className="mt-3"><OperatorCycleHealth report={report} cycleId={cycleId} stores={stores}/></div></details>
   <Button variant="outline" size="sm" onClick={onSupport}>Technical log for support</Button>
  </div>
 </DialogContent></Dialog>;
}
